<template>
  <div class="linha-botao-home-container">
    <div class="linha-botao-home">
      <BotaoPadrao
        arredondadoEsquerda
        :desabilita="arNcmSelecionados.length == 0 || loadingListaNcmsSelecionadas"
        nome="Limpar"
        icone="eraser"
        v-b-modal="'ModalLimparNcm'"
      />
      <BotaoPadrao
        class="botao-padding"
        arredondadoEsquerda
        nome="criar cenário"
        icone="angle-right"
        :click="carregaCenario"
        :desabilita="
          !blCriarCenario || arNcmSelecionados.length == 0 || loadingListaNcmsSelecionadas
        "
        cor="azul"
      />
    </div>
  </div>
</template>

<script>
import InformationBallon from "@/components/InformationBallon/InformationBallon.vue";
import BotaoPadrao from "@/components/BotaoPadrao/BotaoPadrao.vue";

export default {
  name: "LineButtons",
  components: {
    InformationBallon,
    BotaoPadrao
  },
  props: {
    blCriarCenario: Boolean,
    blShowCriarCenario: Boolean,
    loadingListaNcmsSelecionadas: Boolean,
    carregaCenario: Function,
    arNcmSelecionados: Array
  }
};
</script>

<style lang="scss">
.linha-botao-home-container {
  width: 100%;
  display: flex;
  justify-content: center;
}
.linha-botao-home {
  // padding: 0 15px;
  margin-left: 10px;
  display: flex;
  width: 100%;
  justify-content: flex-end;
  align-items: center;
  max-width: 1155px;
}
</style>
